export enum TestId {
  // One particular add-to-basket notification bubble popup (multiple can be displayed at a time)
  Popup = 'popup',
}
